<template>
<div>
   <b-table striped hover :items="$store.state.requests" :fields="request_fields"></b-table>
</div>
</template>

<script>
export default {
  name: "RequestView",
  data() {
      return {
        request_items: [],
        request_fields: [
          {key: 'id', label: 'Заявка', sortable: false},
          {key: 'request_type', label: 'Тип заявки', sortable: false},
          {key: 'request_status', label: 'Статус', sortable: false},
          {key: 'request_app_service_type', label: 'Услуга', sortable: false},
          {key: 'start_date', label: 'Заявка от', sortable: false},
          {key: 'end_date', label: 'Завершена', sortable: false}
        ],
      }
    },
}
</script>

<style scoped>

</style>